module.exports = __webpack_public_path__ + "img/ic_d20tire.0f57c710.png";